import React, { FC } from 'react';
import { Field, ErrorMessage, FieldProps } from 'formik';
import Error from '../Error';
import Note from 'src/shared/components/Note';
import { Checkbox, CheckboxOptionType } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

interface CheckBoxComponentProps {
  name: string;
  options?: CheckboxOptionType[];
  onChange?: (e: object | CheckboxChangeEvent) => void;
  title?: string;
  note?: string;
  notetitle?: string;
  disabled?: boolean;
  size?: 'small' | 'default';
}

const CheckBoxComponent: FC<CheckBoxComponentProps> = (props) => {
  const { name, options, onChange, title, note, notetitle, disabled, size } =
    props;

  return (
    <Field name={name}>
      {({ field, form: { errors, touched, setFieldValue } }: FieldProps) => (
        <div className="checkbox-button">
          {title && <div className="field-title">{title}</div>}
          <Checkbox.Group
            {...field}
            {...props}
            value={field.value}
            options={options}
            disabled={disabled}
            onChange={(e) => {
              setFieldValue(name, e);
              if (onChange) {
                onChange(e);
              }
            }}
            className={`${touched[name] && errors[name] ? 'error' : ''} ${
              size === 'small' ? 'small' : ''
            }`}
          />
          <div className="error-holder">
            <ErrorMessage name={name}>
              {(message: string) => <Error message={message} />}
            </ErrorMessage>
          </div>
          {note && <Note note={note} title={notetitle} className="mt-2" />}
        </div>
      )}
    </Field>
  );
};

export default CheckBoxComponent;
